<script setup>
import router from '@/router';
import {getMessageListAPI,setReadAPI} from '@/apis/user'
const timer = ref(null);
import { useUserStore } from '@/stores/userStore';
const userStore = useUserStore()
const isMobile=ref(false);//代表pc
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    console.log('Is mobile device:', isMobile.value);
    // if(isMobile.value==false){
        if(userStore.userInfo.token){
            getMessage()
        // 组件挂载后设置定时器
        timer.value = setInterval(getMessage, 50000);
        }
    // }
   
     // 每1000毫秒（1秒）调用一次doSomething方法
});
onBeforeUnmount(() => {
    // 组件卸载前清除定时器
    if (timer.value) {
    clearInterval(timer.value);
    }
});
const messageList=ref()
const unread=ref()
const selIndex = ref(-1)
const getMessage=async ()=>{
    const res = await getMessageListAPI({is_read:null })
            if (res.code == 0) {
                messageList.value=res.data.list
                unread.value=res.data.unread
            } else {
                ElMessage({ type: 'error', message: res.message })
            }
}
const setRead = async (id, type, index) => {
    if (index == selIndex.value) {
        selIndex.value = -1
    } else {
        selIndex.value = index
    }
    if (type == 1) {
        const res = await setReadAPI({ message_id: id })
        if (res.code == 0) {
            console.log('成功')
            getMessage()
        }
    }

}


</script>
<template>
    <div class="notifyPage" v-if="isMobile==false">

        <el-popover placement="bottom"  :width="240" trigger="click" class="popoverdev"
           >
            <template #reference>
                <a class="curr" href="javascript:;">
                    <svg-icon icon-class="notify" style="width: 25px;height: 25px;    margin-top: 6px;"></svg-icon>
                    <em><div v-if="unread<100">{{unread}}</div>
                        <svg-icon v-else icon-class="point" style="width: 12px;height: 12px;"></svg-icon></em>
                </a>
            </template>
            <!-- <div class="demo-collapse" style="height: 300px;overflow: auto;"> -->
                <!-- <el-collapse accordion>
                    <el-collapse-item :name="item.id" v-for="(item,i) in messageList" :key="i" @click="setRead(item.id,item.is_read)">
                        <template #title>
                            <div class="title" style="width: 160px;white-space: nowrap;overflow: hidden; text-overflow: ellipsis;">
                                {{ item.title }} 
                            </div>
                            <svg-icon v-if="item.is_read==1" icon-class="Unread" />
                        </template>
                        <div>
                        {{ item.message }}
                        </div>
                    
                    </el-collapse-item>
                </el-collapse> -->
                <div class="demo-collapse" style="height: 300px;overflow: auto;">
                    <div class="el-collapse" v-for="(item, i) in messageList" @click="setRead(item.id, item.is_read, i)" :key="i">
                        <div class="title">
                            <div>
                                <div style="white-space: nowrap;overflow: hidden; text-overflow: ellipsis;">
                                    {{ item.title }}
                                </div>

                                <svg-icon v-if="item.is_read == 1" icon-class="Unread" />
                            </div>
                            <div class="svg-icon" :class="i == selIndex ? 'sel-icon' : ''"><svg-icon icon-class="you" /></div>

                        </div>
                        <div class="message" v-show="i == selIndex">{{ item.message }}</div>
                    </div>
                </div>
            <!-- </div> -->
        </el-popover>
    </div>
    <div class="phoneNotifyPage" v-else>
        <div @click="router.push('/internal')">
            <a class="curr" href="javascript:;">
                    <svg-icon icon-class="notify" style="width: 18px;height: 18px;    margin-top: 6px;"></svg-icon>
                    <em>
                        <div v-if="unread<100">{{unread}}</div>
                        <svg-icon v-else icon-class="point" style="width: 12px;height: 12px;"></svg-icon>
                    </em>
                </a>
        </div>
    </div>
</template>
<style scoped lang='scss'>
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
    width: 0.01rem;
    opacity: 0;
    display: none;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
    background-color: #fff;
    opacity: 0;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
    width: 0.01rem;
    border-radius: 0.01rem;
    opacity: 0;
}
.notifyPage {
    width: 50px;
    position: relative;
    .popoverdev{
        height: 300px;
        overflow: auto;
    }
    .curr {
        height: 32px;
        line-height: 32px;
        text-align: center;
        position: relative;
        display: block;

        img {}


        em {
            font-style: normal;
            position: absolute;
            right: 0;
            top: 0;
            padding: 1px 6px;
            line-height: 1;
            background: $helpColor;
            color: #fff;
            font-size: 12px;
            border-radius: 10px;
            font-family: Arial;
        }
    }
    .title{
        width: 160px;
        white-space: nowrap; 
        overflow: hidden; 
        text-overflow: ellipsis;
    }
}
.demo-collapse {
        padding: 10px 0 0 0;

        .el-collapse {
            padding: 0 20px;
            border: none;
            border-bottom: 1px solid #F3F6F8;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #222222;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            .title {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 48px;
                >div {
                    display: flex;
                    align-items: center;
                }
                .svg-icon {
                    width: 21px;
                    height: 21px;
                    border-radius: 50%;
                    background-color: #F8F8F8;
                    justify-content: center;
                    transform: rotate(0deg);
                    transition:all .5s;
                }

                .sel-icon {
                    transform: rotate(90deg);
                    transition:all .5s;
                }
            }

            .message {
                padding-bottom: 13px;
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #666666;
                line-height: 25px;
                text-align: left;
                font-style: normal;
            }
        }
    }
@media (max-width: 768px) {
    .phoneNotifyPage{
        width: 23px;
        .curr {
        height: 32px;
        line-height: 32px;
        text-align: center;
        position: relative;
        display: block;

        img {}


        em {
            font-style: normal;
        position: absolute;
        right: 0;
        top: 0;
        left: 10px;
        padding: 1px 3px;
        line-height: 1;
        background: #e26237;
        color: #fff;
        font-size: 10px;
        border-radius: 7px;
        font-family: Arial;
        }
    }
    }
}
</style>